export default {
  selected: '선택됨',
  deselect_all_selected_options: '선택한 모든 옵션 선택 취소',
  expanded: '확장됨',
  collect: '수집',
  no_options_available: '사용 가능한 옵션이 없습니다',
  required: '필수',
  input_clear_aria_label: '입력 지우기',
  input_show_hide_password_aria_label: '비밀번호 표시 또는 숨기기',
  input_increment_aria_label: '값 증가',
  input_decrement_aria_label: '값 감소',
  english: '영어',
  chinese: '중국어',
  portuguese: '포르투갈어',
  spanish: '스페인어',
  dutch: '네덜란드어',
  french: '프랑스어',
  german: '독일어',
  russian: '러시아어',
  ukrainian: '우크라이나어',
  korean: '한국어',
  italian: '이탈리아어',
  czech: '체코어',
  access_your_account: '계정에 액세스',
  use_your_company_credentials_to_get_started: '회사 자격 증명을 사용하여 시작',
  this_link_has_expired: '이 링크가 만료되었습니다',
  login: '로그인',
  sample_no_production_date_message: '생산 날짜는 필수',
  free_comment: '프리 코멘트',
  save_comments: '저장 및 닫기',
  round_list_rounds: '라운드',
  round_edit_round: '라운드 편집',
  round_new_round: '라운드 추가',
  round_remove_round: '이 라운드를 삭제하시겠습니까?',
  round_schedule: '계획',
  round_tasters_unselect_all: '모든 관능자 선택 취소',
  round_tasters_select_all: '모든 관능자 선택',
  round_close: '라운드 닫기',
  round_close_message: '이 라운드를 마무리하시겠습니까?',
  round_create_site_message:
    '자신의 공장 속하지 않는 라운드를 만들고 있습니다!',
  round_closed_message: '닫힌 라운드는 편집할 수 없습니다.',
  round_status_created: '작성',
  round_status_samples: '샘플',
  round_status_scheduled: '예정됨',
  round_status_tasters: '관능자',
  round_status_in_progress: '진행 중',
  round_status_finished: '완성됨',
  round_status_closed: '글로즈',
  round_schedule_start_finish_date:
    '시작 날짜는 종료 날짜보다 늦으면 안됩니다!',
  round_schedule_finish_date_no_start_date: '시작 날짜를 먼저 선택하세요!',
  round_disabled_discussion_tooltip:
    '완료되지 않은 라운드의 토론으로 이동할 수 없습니다.',
  round_up_down_maintenance_tooltip:
    '현재 기능은 유지보수 중이며 일시적으로 사용할 수 없습니다.',
  round_delete_other_users_rounds:
    '사용자가 만들지 않은 라운드를 삭제할 수 있는 권한이 없습니다.',
  round_randomize_samples_order_button: '셔플',
  round_block_results_tooltip:
    '보고서 화면에서 이 라운드의 결과를 다운로드하지 못하도록 잠급니다. 버튼을 사용할 수 없는 경우 이 위치에서 라운드 결과를 잠글 수 있는 권한이 없습니다.',
  round_block_results_confirm:
    '이번 관능 보고서 다운로드를 금지/해제하시겠습니까?',
  round_block_results_no_privilege:
    '이 위치에서 라운드 결과를 금지/해제할 수 있는 권한이 없습니다.',
  sample_list_samples: '샘플',
  sample_edit_sample: '샘플 편집',
  sample_new_sample: '새로운 샘플',
  sample_remove_sample: '샘플 제거',
  sample_upload_document: '파일 업로드',
  sample_download_documents: '파일 다운로드',
  sample_tasted_dates: '관능 날짜',
  sample_upload_message: '여러 파일을 업로드하려면 여기에 추가하세요',
  sample_not_for_kpi: 'KPI에 적용되지 않음',
  sample_package: '패키지',
  sample_volume: '용량',
  sample_production_date: '생산 날짜',
  sample_expire_date: '만기일',
  sample_trial_identifier: '평가판 식별자',
  sample_project_name: '프로젝트 이름',
  sample_linked: '새로운 라운드에 연결',
  sample_expire_bigger_than_production:
    '생산 날짜는 만기일보다 늦을 수 없습니다!',
  sample_no_site_message:
    '샘플을 생성하려면 존, 국가 및 공장을 선택해야 합니다.',
  sample_no_brand_message: '브랜드를 선택해야 합니다.',
  sample_duplicated_kpi_message:
    '선택한 월, 브랜드 및 공장에는 KPI가 이미 있으므로 저장할 수 없습니다.',
  sample_duplicated_kpi_message_quarter:
    '선택하신 분기, 브랜드 및 사이트에 대한 KPI가 이미 설정되어 있어 저장하실 수 없습니다.',
  sample_duplicated_project_message:
    '이 사이트 및 브랜드에 대한 이 프로젝트 이름 및 평가판 식별자가 있는 샘플이 이미 있으므로 저장할 수 없습니다',
  sample_project_no_name_or_trial:
    '프로젝트 이름과 평가판 식별자는 필수 항목입니다.',
  sample_production_to_project_confirm_message:
    '이 샘플의 타입을 제품에서 프로젝트로 변경 중입니다. 계속하시겠습니까?',
  sample_project_to_production_confirm_message:
    '이 샘플의 타입을 프로젝트에서 제품으로 변경하고 있습니다. 계속하시겠습니까?',
  sample_no_volume_message:
    '샘플을 생성/편집할 때 패키지 및 용량은 필수입니다.',
  sample_id_code_message: '전체 배치 번호를 포함해 주세요.',
  sample_show_all_samples_hint:
    '오늘부터 6개월까지 생성된 샘플을 보여줍니다. 이전 샘플을 보려면 이 확인란을 선택합니다.',
  sample_show_all_samples_label: '모든 샘플 표시',
  package_duplicate: '이 이름을 가진 패키지가 이미 있습니다.',
  common_production: '생산',
  day: '일',
  common_project: '프로젝트',
  group_list_groups: '그룹',
  group_edit_group: '그룹 편집',
  group_new_group: '그룹 추가',
  group_remove_group: '그룹 삭제',
  group_close_modal: '닫기',
  group_duplicated_user: '이 사용자는 이미 이 그룹에 추가되었습니다!',
  group_no_name_message: '그룹 이름은 필수입니다',
  group_no_zone_message: '존 선택해야 합니다.',
  group_no_users_message: '하나 이상의 관능자를 선택해야 합니다.',
  family_list_families: '유형',
  family_edit_family: '유형 편집',
  family_new_family: '새로운 유형',
  family_remove_family: '유형 삭제',
  families_page_description: '모든 스타일과 해당 구성을 한 곳에서 관리하세요',
  family_new_page_description: '스타일 정보를 입력하고 생성을 완료하세요.',
  family_edit_page_description: '스타일 정보를 편집하세요.',
  family_save_success: '스타일이 성공적으로 생성되었습니다!',
  family_update_success: '스타일이 성공적으로 업데이트되었습니다!',
  family_save_failed: '스타일 저장에 실패했습니다.',
  family_save_success_desc: '아래 스타일에서 확인하세요.',
  family_update_success_desc: '아래 스타일에서 확인하세요.',
  family_save_failed_desc: '잠시 후 다시 시도해주세요.',
  the_name_is_duplicated: '이름이 중복됩니다.',
  common_style_name: '스타일 이름',
  common_warning: '경고',
  cancel_new_family_title: '새 스타일을 취소하시겠습니까?',
  cancel_edit_family_title: '스타일 편집을 취소하시겠습니까?',
  cancel_new_family_confirm: '새 스타일 취소',
  cancel_edit_family_confirm: '스타일 편집 취소',
  family_remove_success: '스타일이 성공적으로 삭제되었습니다',
  family_remove_failed: '스타일 삭제에 실패했습니다',
  family_delete_title: '스타일을 삭제하시겠습니까?',
  family_delete_description:
    '{{name}} 스타일이 영구적으로 삭제됩니다. 계속하시겠습니까?',
  family_delete_success: '스타일이 성공적으로 삭제되었습니다!',
  family_delete_success_desc: '스타일이 삭제되었습니다.',
  family_delete_failed: '스타일 삭제에 실패했습니다.',
  family_delete_failed_desc: '잠시 후 다시 시도해주세요.',
  family_has_no_english_name: '참고: 유형 이름은 영어여야 합니다.',
  brand_list_brands: '브랜드',
  brand_edit_brand: '브랜드 편집',
  brand_new_brand: '새로운 브랜드',
  brand_remove_brand: '브랜드 제거',
  brand_profile_picture: '맥주 프로필 사진 업로드',
  brand_upload_brand_logo: '브랜드 로고 업로드',
  brand_duplicate: '경고: 이 이름의 맥주가 이미 있습니다.',
  brand_has_no_english_name: '브랜드 이름이 하나 이상 있어야 합니다.',
  brand_upload_help_message: 'PNG 및 JPG 파일만',
  brand_has_no_product_type: '제품 타입을 선택해야 합니다.',
  package_list_packages: '패키지',
  package_edit_package: '패키지 편집',
  package_new_package: '새로운 패키지',
  package_remove_package: '패키지 삭제',
  packages_page_description:
    '모든 패키지 유형과 해당 구성을 한 곳에서 관리하세요.',
  comments_page_description: '모든 속성과 해당 구성을 한 곳에서 관리하세요.',
  comments_new_page_description: '속성 정보를 입력하고 생성을 완료하세요.',
  comments_edit_page_description: '속성 정보를 편집하고 업데이트를 완료하세요.',
  comment_attribute_name: '플레이버 속성 이름',
  comment_select_category: '플레이버 카테고리 선택',
  packages_edit_page_description:
    '패키지 정보를 편집하고 업데이트를 완료하세요.',
  package_successfully_created: '패키지가 성공적으로 생성되었습니다!',
  package_successfully_created_desc: '아래 패키지에서 확인하세요.',
  package_successfully_updated: '패키지가 성공적으로 업데이트되었습니다!',
  package_successfully_updated_desc: '아래 패키지에서 확인하세요.',
  packages_new_page_description: '포장지 정보를 입력하고 생성을 완료하세요.',
  package_name: '포장지 이름',
  content_already_exists: '콘텐츠가 이미 존재합니다.',
  language_english: '영어',
  language_chinese: '중국어',
  language_portuguese: '포르투갈어',
  language_spanish: '스페인어',
  language_dutch: '네덜란드어',
  language_french: '프랑스어',
  language_german: '독일어',
  language_russian: '러시아어',
  language_ukrainian: '우크라이나어',
  language_korean: '한국어',
  language_italian: '이탈리아어',
  package_has_no_english_name:
    '주의: 패키지 이름은 반드시 영어로 입력해야 합니다.',
  package_volumes: '용량',
  package_new_volume: '새로운 용량',
  package_remove_volume: '용량 삭제',
  degree_list_degrees: '강도',
  degree_edit_degree: '강도 편집',
  degree_new_degree: '강도 추가',
  degree_remove_degree: '강도 삭제',
  category_list_categories: '카테고리',
  category_edit_category: '플레이버 카테고리 편집',
  category_new_category: '새로운 플레이버 카테고리',
  category_remove_category: '플레이버 카테고리 삭제',
  comment_list_comments: '속성',
  comment_edit_comment: '플레이버 속성 편집',
  comment_new_comment: '새로운 플레이버 속성',
  comment_remove_comment: '플레이버 속성 삭제',
  comment_cancel_new_title: '새 플레이버 속성을 취소하시겠습니까?',
  comment_cancel_edit_title: '플레이버 속성 편집을 취소하시겠습니까?',
  comment_cancel_new_confirm: '새 플레이버 속성 취소',
  comment_cancel_edit_confirm: '플레이버 속성 편집 취소',
  comment_successfully_created: '플레이버 속성이 생성되었습니다!',
  comment_successfully_created_desc: '아래 속성에서 확인해 보세요.',
  comment_successfully_updated: '플레이버 속성이 업데이트되었습니다!',
  comment_successfully_updated_desc: '아래 속성에서 확인해 보세요.',
  comment_create_failed: '플레이버 속성 생성에 실패했습니다.',
  comment_update_failed: '플레이버 속성 업데이트에 실패했습니다.',
  comment_failed_desc: '잠시 후 다시 시도해 주세요.',
  comment_delete_title: '속성을 삭제하시겠습니까?',
  comment_delete_description:
    '{{name}} 속성이 영구적으로 삭제됩니다. 계속하시겠습니까?',
  comment_delete_success: '속성이 삭제되었습니다!',
  comment_delete_success_desc: '아래 속성에서 확인해 보세요.',
  comment_delete_failed: '속성 삭제에 실패했습니다.',
  comment_delete_failed_desc: '잠시 후 다시 시도해 주세요.',
  user_list_users: '사용자',
  user_edit_user: '사용자 편집',
  user_new_user: '신규 ABI 계약자',
  user_export_users: '사용자 내보내기',
  user_list_profiles: '프로필',
  user_profile_name: '프로필 이름',
  user_profile_select: '프로필 선택',
  user_profile_remove: '프로필 제거',
  user_profile_save: '프로필 저장',
  user_remove_user: '사용자 삭제',
  user_use_terms: '수락된 사용 약관',
  report_list_report: '보고서',
  report_start_date: '시작일',
  report_end_date: '종료일',
  common_privileges: '권한',
  common_abi_name: 'ABI 이름',
  common_id: 'ID',
  common_ranked: '순위',
  common_week: '주',
  common_weeks: '주',
  common_days: '일',
  common_category: '플레이버 카테고리',
  common_category_sample: '카테고리',
  common_degree: '강도',
  common_comment: '플레이버 속성',
  common_status: '상태',
  common_zone: '존',
  common_country: '국가',
  common_site: '공장',
  common_start_date: '시작 날짜',
  common_finish_date: '종료 날짜',
  common_round_type: '관능 타입',
  common_type: '타입',
  common_round: '라운드',
  common_round_id: '라운드 ID',
  common_tasters: '관능자',
  common_taster: '관능자',
  common_sample_performance: '샘플 성능',
  common_taste: '관능',
  common_key_taster: '관능',
  common_sample: '샘플',
  common_samples: '샘플',
  common_sample_type: '샘플 타입',
  common_family: '스타일',
  common_brand: '브랜드',
  common_product_type: '제품 타입',
  common_temperature: '저장 조건',
  common_storage_times: '저장 시간',
  common_sku: 'SKU',
  common_batch: '아이디 코드',
  common_kpi_month: 'KPI 월',
  common_logo: '로고',
  common_name: '이름',
  common_notes: '메모',
  common_email: '이메일',
  common_language: '언어',
  common_terms_of_use: '이용약관',
  common_new: '새로운',
  common_profile: '프로필',
  common_filter: '사용자 필터',
  common_download: '다운로드',
  download: '다운로드',
  common_save: '저장',
  common_cancel: '취소',
  cancel_add_taster_title: '테이스터 추가를 취소하시겠습니까?',
  cancel_add_taster_description:
    '테이스터를 이미 선택했습니다. 취소하면 선택한 내용이 삭제됩니다. 계속하시겠습니까?',
  cancel_add_taster_confirm: '테이스터 추가 취소',
  cancel_enter_concentration_title: '농도 입력을 취소하시겠습니까?',
  cancel_enter_concentration_description:
    '농도 값을 입력했습니다. 취소하면 저장되지 않은 입력 내용이 삭제됩니다. 계속하시겠습니까?',
  cancel_enter_concentration_confirm: '농도 입력 취소',
  cancel_new_package_title: '새 패키지를 취소하시겠습니까?',
  cancel_edit_package_title: '패키지 편집을 취소하시겠습니까?',
  cancel_new_package_confirm: '새 패키지 취소',
  cancel_edit_package_confirm: '패키지 편집 취소',
  common_search_users: '사용자 검색',
  common_search_group: '그룹 검색',
  common_search_taster: '관능자 검색',
  common_no_data: '표시할 데이터가 없습니다.',
  common_edit: '편집',
  no_results_found_for_applied_filters:
    '적용된 필터에 대한 결과를 찾을 수 없습니다',
  common_loading: '로딩 중...',
  common_search: '검색...',
  type_more_characters: '{{count}}자(들) 더 입력하세요...',
  common_cannot_be_empty: '{{field}}는 비워둘 수 없습니다.',
  common_select_option: '옵션 선택...',
  search_placeholder: '검색...',
  no_search_results: '결과를 찾을 수 없습니다',
  clear_selection: '선택 해제',
  common_per_page: '페이지당 행 수',
  common_attributes: '속성',
  common_not_started: '미시작',
  common_in_progress: '진행 중',
  common_finished: '완성됨',
  common_start: '시작',
  common_detail: '상세 보기',
  common_delete: '삭제',
  common_position: '위치',
  common_average_key_score: '평균 점수',
  common_score: '점수',
  common_score_scale: '점수 표준',
  common_intensity: '강도',
  common_report_not_have_data: '선택한 라운드에는 결과가 없습니다.',
  month_0: '1월',
  month_1: '2월',
  month_2: '3월',
  month_3: '4월',
  month_4: '5월',
  month_5: '6월',
  month_6: '7월',
  month_7: '8월',
  month_8: '9월',
  month_9: '10월',
  month_10: '11월',
  month_11: '12월',
  dropdown_change_picture: '사진 변경',
  dropdown_language: '언어',
  dropdown_logout: '로그아웃',
  logout_title: '로그아웃 중입니다. 잠시 기다려 주세요…',
  logout_description: '계정에서 로그아웃하고 있습니다.',
  round_not_started: '미시작',
  round_in_progress: '진행 중',
  round_finished: '완성됨',
  round_filter_start: '시작',
  tasting_list_rounds: '라운드 나열',
  menu_tasting_session: '나의 관능',
  menu_panel_management: '관능 관리',
  menu_process_management: '프로세스 관리',
  menu_product_management: '제품 관리',
  menu_attributes_management: '속성 관리',
  tasting_finish_sample: '관능 완료',
  tasting_comments: '코멘트',
  tasting_beer_profile: '맥주 프로필',
  tasting_need_select_score_comments:
    '계속하려면 점수를 설정하고 코멘트를 하나 이상 추가해야 합니다...',
  tasting_finish_taste: '관능 완료',
  tasting_finish_tasting: '관능 완료',
  common_no_comments: '코멘트 없음',
  previous_comments: '이전 댓글',
  review_submit_title: '결과를 제출하시곘습니까?',
  review_submit_description: '추후에 편집할 수 없습니다.',
  review_finish_taste: '관능 완료',
  review_warning_sample_title: '관능하지 않은 샘플이 있습니다!',
  review_warning_sample_description: '관능하지 않고 계속하시겠습니까?',
  review_warning_sample_review: '검토',
  review_warning_sample_ok: '계속',
  review_warning_preference_description: '계속하기 전에 선호도를 선택하세요.',
  review_warning_tie_sample_title: '샘플을 이미 묶었습니다!',
  review_warning_tie_sample_description:
    '순위를 매기지 않고는 계속할 수 없습니다!',
  review_warning_tie_sample_review: '검토',
  common_submit: '제출',
  common_discussion: '논의',
  common_not_informed: '알림이 없음',
  discussion_order_number: '위치별 순서',
  discussion_order_brewery: '공장별 순서',
  discussion_order_ranking: '순위별 순서',
  discussion_order_brand: '브랜드별 순서',
  discussion_order_score: '점수별 순서',
  discussion_order_key_score: '키 점수별 순서',
  discussion_order_overall_rank: '전체 순위별 순서',
  discussion_order_key_rank: '키 순위별 순서',
  discussion_export_error: '파일을 저장할 수 없습니다!',
  discussion_ranking: '순위',
  discussion_overall_ranking: '전체 순위',
  discussion_key_ranking: '키 순위',
  common_brewery: '공장',
  common_trial_identifier: 'ID 평가판',
  common_key_score: '키 점수',
  round_report: '엑셀로 내보내기',
  common_comments: '코멘트',
  message_you_cannot_delete_all_comments:
    '평가 결과를 편집할 때 모든 코멘트를 삭제할 수 없습니다.',
  common_message_empty_profile: '프로파일 이름이 비어 있을 수 없습니다.',
  common_message_out_score_range: '점수가 범위를 벗어난다.',
  tasting_need_select_score: '점수를 먼저 설정해야 합니다!',
  common_category_name: '카테고리',
  categories_new_category: '새로운 카테고리',
  categories_remove_category: '새 카테고리',
  categories_list_categories: '카테고리',
  categories_list_all_categories: '모든 카테고리',
  common_category_sample_name: '샘플',
  categories_new_category_sample: '새로운 샘플',
  categories_remove_category_sample: '샘플을 제거하시겠습니까',
  categories_list_categories_samples: '샘플',
  tasting_help: '관능 도움말',
  common_back: '되로가기',
  common_next: '다음',
  common_sample_id: '샘플 ID',
  common_sample_date: '샘플 날짜',
  common_duplicate: '복제',
  tasting_raw_materials: '원재료',
  tasting_example_sensory_risk:
    '주요 관능 리스크 예시: 예상한 입맛에 맞지 않다',
  tasting_procedure: '프로세스',
  tasting_sample_preparation: '샘플 준비',
  tasting_help_comments: '코멘트',
  common_collection_point: '수집 장소',
  common_collection_date: '수집일',
  common_brew_number: '맥주 번호/MES 번호',
  common_need_explain_nok: 'NOK를 가진 샘플에 코멘트 추가해야 합니다!',
  common_percent_ok: 'OK 비율',
  common_show_all: '모두 표시',
  common_import: '가져오기',
  common_download_template: '템플릿 다운로드',
  sample_import_message: 'xlsx',
  common_template: '템플릿',
  common_yes: '예',
  common_no: '아니요',
  logging_out: '로그아웃 중...',
  common_only_kpi_sample: 'KPI 샘플만',
  common_need_volte_first: '먼저 결과 없이 샘플에 코멘트할 수 없습니다!',
  common_name_template: '템플릿 이름',
  interaction_log: '상호작용 로그',
  common_message_zone_empty: '존은 비어 있을 수 없습니다.',
  common_message_country_empty: '국가는 비어 있을 수 없습니다.',
  common_message_site_empty: '공장은 비어 있을 수 없습니다.',
  user_new_profile_save: '새 프로필이 생성됨',
  common_in_privileges: '특권',
  common_download_files: '파일 다운로드',
  common_create_action: '액션 생성',
  common_action_list: '액션 목록',
  common_create_action_description:
    '이 샘플에 대한 액션 세부정보를 입력하세요.',
  common_optional: '선택',
  action_deadline: '마감일',
  action_description: '액션 설명',
  action_description_autofill_tooltip: '액션 설명',
  action_description_autofill_tooltip_description:
    '자동 생성 (라운드 ID / 양조장 / 샘플명 / 생산일 / 생성 사용자) + 추가 설명',
  action_owner: '담당자',
  action_meeting: '상호작용 로그 회의',
  action_meeting_list: 'IAL 회의',
  action_producing_site: '생산 사이트',
  action_production_date: '생산 날짜',
  action_closed_time: '종료 시간',
  action_meeting_placeholder: '회의를 선택하세요',
  action_status: '상태',
  action_status_draft: '초안',
  action_status_not_started: '시작 안 됨',
  action_status_in_progress: '진행 중',
  action_status_delayed: '지연됨',
  action_status_close: '닫기',

  action_menu_close: '닫기',
  common_view_details: '세부 정보 보기',
  action_cancel: '취소',
  action_add_comment: '댓글 추가',
  action_status_canceled: '취소됨',
  status_record: '상태 기록',
  no_status_record: '상태 기록 없음',
  action_type: '액션 유형',
  action_create_user: '생성자',
  action_create_time: '생성 시간',
  action_creator: '생성자',
  action_root_cause: '근본 원인',
  action_description_placeholder: '액션 설명을 입력하세요...',
  action_root_cause_placeholder: '근본 원인을 입력하세요...',
  action_comment_added: '댓글이 성공적으로 추가되었습니다',
  action_comment_add_failed: '댓글 추가에 실패했습니다',
  action_comment_placeholder: '댓글을 입력하세요...',
  action_status_changed_with_comment: '댓글과 함께 상태가 변경되었습니다',
  required_comment_banner:
    '이 액션의 소유자가 아니므로 소유자를 대신하여 댓글을 제공해야 합니다.',
  cancel_and_comment: '취소하고 댓글 달기',
  close_and_comment: '닫고 댓글 달기',
  action_edit_action: '액션 편집',
  action_owner_placeholder: '담당자를 선택하세요',
  action_created_successfully: '액션이 성공적으로 생성되었습니다!',
  action_created_successfully_desc: '액션 목록에서 생성된 액션을 확인하세요.',
  action_updated_successfully: '액션이 성공적으로 업데이트되었습니다!',
  action_updated_successfully_desc:
    '액션 목록에서 업데이트된 액션을 확인하세요.',
  action_create_failed: '액션 생성 중 문제가 발생했습니다',
  action_update_failed: '액션 업데이트 중 문제가 발생했습니다',
  action_save_failed_desc: '잠시 후 다시 시도해 주세요.',
  action_deleted_successfully: '액션이 성공적으로 삭제되었습니다!',
  action_deleted_successfully_desc: '액션 목록에서 확인하세요.',
  action_delete_failed: '액션 삭제 중 문제가 발생했습니다',
  delete_action_confirm_title: '액션을 삭제하시겠습니까?',
  delete_action_confirm_description:
    '이 액션은 영구적으로 삭제됩니다. 계속하시겠습니까?',
  action_added_notification: '[{{userName}}]님이 새 액션을 추가했습니다',
  action_updated_notification: '[{{userName}}]님이 액션을 업데이트했습니다',
  action_deleted_notification: '[{{userName}}]님이 자신의 액션을 삭제했습니다',
  view_action_list: '액션 목록 보기',
  pdf_viewer: 'PDF 보기',
  common_all: '모든',
  common_continue: '계속',
  common_minimum_score: '최소',
  common_maximum_score: '최대',
  common_average_score: '평균',
  file_upload_fail: '파일을 업로드하지 못했습니다. 다음 오류가 발생했습니다.',
  file_upload_success_with_error: '업로드 성공했지만 다음을 제외합니다:',
  missing_fields: '필드 누락',
  column_error: '열 오류',
  common_line: '행',
  file_no_samples: '파일에 샘플이 없습니다 !',
  file_success_upload: '파일 업로드 성공',
  file_duplicated_kpi_project: '중복된 KPI 또는 프로젝트',
  round_schedule_maximum_length: '라운드 이름의 최대 길이는 40자입니다.',
  sample_malt_varieties: '맥아 품종',
  error_sample_already_in_round: '샘플은 이미 라운드 중입니다.',
  malt_varieties_has_no_english_name:
    '하나 이상의 맥아 품종 이름이 있어야 합니다.',
  malt_varieties_duplicate: '참고: 이 이름을 가진 맥아 품종이 이미 있습니다.',
  malt_varieties_remove: '품종 삭제',
  malt_varieties_new: '새로운 품종',
  malt_varieties_edit: '품종 편집',
  malt_varieties_enter_name: '이름 입력',
  malt_varieties_page_description:
    '모든 맥아 품종과 해당 구성을 한 곳에서 관리하세요.',
  malt_varieties_save_success: '맥아 품종이 성공적으로 생성되었습니다!',
  malt_varieties_save_success_desc: '아래 맥아 품종에서 확인하세요.',
  malt_varieties_update_success: '맥아 품종이 성공적으로 수정되었습니다!',
  malt_varieties_update_success_desc: '아래 맥아 품종에서 확인하세요.',
  malt_varieties_delete_title: '맥아 품종을 제거하시겠습니까?',
  malt_varieties_delete_description:
    '{{name}} 맥아 품종이 영구적으로 제거됩니다. 계속하시겠습니까?',
  malt_varieties_delete_success: '맥아 품종이 성공적으로 삭제되었습니다!',
  malt_varieties_delete_success_desc: '아래 맥아 품종에서 확인하세요.',
  malt_varieties_delete_failed: '맥아 품종 삭제에 실패했습니다.',
  malt_varieties_delete_failed_desc: '잠시 후 다시 시도해 주세요.',
  cancel_new_malt_variety_title: '새 맥아 품종을 취소하시겠습니까?',
  cancel_edit_malt_variety_title: '맥아 품종 편집을 취소하시겠습니까?',
  cancel_new_malt_variety_confirm: '새 맥아 품종 취소',
  cancel_edit_malt_variety_confirm: '맥아 품종 편집 취소',
  reports_no_dates: '시작 날짜와 종료 날짜는 필수입니다!',
  reports_date_range_message: '날짜 범위는 1년을 초과할 수 없습니다 !',
  round_save_select_site: '라운드를 저장하려면 공장을 선택해야 합니다.',
  common_error: '문제가 발생했습니다. 다시 한번 하십시오.',
  common_horizontal: '수평 레이아웃',
  common_unit: '구성 단위',
  common_supplier: '공급자',
  common_flavor: '플레이버',
  concentration_of_the_base_beer: '기본 맥주의 농도',
  threshold_aml_method: 'AML 방법(한계 상승 방법)',
  threshold_component_concentration: '성분 농도',
  threshold_sample_different_help: '어떤 샘플이 다른가요?',
  threshold_each_set_random_order: '각 집합에서 랜덤 순서입니다.',
  threshold_select_base_beer: '기본 맥주 선택',
  common_unity: '통일',
  common_finish_session: '관능 완료',
  common_filters: '필터',
  review_submit_threshold: '저장하시겠습니까?',
  threshold_coder_wrong: '코드가 틀렸습니다. 올바른 코드를 입력하십시오!',
  threshold_didnt_enter_the_code: '코드를 입력하지 않았습니다!',
  code: '코드',
  common_batch_code: '배치 코드',
  threshold_samples_required: '기본 맥주 및 플레이버가 필요합니다.',
  threshold_information_helper_sample:
    '임계값 샘플 정보를 저장하려면 Save(저장) 버튼을 클릭하여 변경 내용을 유지하십시오.',
  code_digits: '할당된 3자리 코드를 입력합니다.',
  threshold_sample_spiked_with:
    '각 세트에서 다음과 같이 스파이크된 샘플을 선택합니다.',
  threshold_code_already_tasted:
    '이 코드는 이미 다른 사용자가 사용한 코드입니다. 다른 코드를 입력하십시오.',
  common_kpi_brands: 'KPI 브랜드',
  common_year: '년',
  common_new_kpi_brand: '새로운 KPI 브랜드',
  common_action: '액션',
  kpi_brand_details_title: 'KPI 브랜드 상세정보',
  kpi_brand_details_description:
    '완전한 정보와 승인 프로세스 상태를 확인하세요.',
  approval_action: '승인 작업',
  select_approval_action: '승인 작업 선택',
  reject_reason_title: '거부 사유',
  reject_reason_description: '거부 사유를 입력해 주세요.',
  reject_reason_label: '거부 사유',
  reject_reason_placeholder: '거부 사유를 입력하세요...',
  reject_reason_placeholder_site:
    "이 사이트 '{{site}}'에 대한 거부 사유를 입력하세요...",
  common_confirm: '확인',
  common_success: '성공',
  common_save_failed: '저장에 실패했습니다. 다시 시도해 주세요.',
  approval_status_saved_success: '승인 상태가 성공적으로 저장되었습니다!',
  common_comment_by_category: '카테고리별 코멘트',
  common_alphabetic_comment: '알파벳 코멘트',
  common_name_pts_code: 'PTS 코드',
  common_name_pts_code_placeholder: '코드',
  common_name_process_item: '프로세스 항목',
  common_name_process_item_placeholder: '항목',
  common_global_brands: '글로벌 브랜드',
  common_global_brand: '글로벌 브랜드',
  common_target_global_brand: '글로벌 브랜드 대상',
  common_focus_brand: '포커스 브랜드',
  common_target_focus_brand: '포커스 브랜드 대상',
  common_strategic_brand: '전략 브랜드',
  common_target_strategic_brand: '전략 브랜드 대상',
  common_maximun_sites: '비교할 최대 공장 수:',
  common_state_reason_rejecting: '이 공장에 대한 거부 이유 설명',
  common_rejected_note: '거부된 노트',
  report_list_report_kpi: 'KPI 보고서',
  report_list_report_taste: '평가 보고서',
  select_brand_to_filter: '글로벌 브랜드를 선택하십시오!',
  select_year_to_filter: '연도를 선택하십시오!',
  kpi_only_numbers_warning: '목표 값의 숫자만 허용',
  kpi_max_number_range_warning: '대상 브랜드는 1에서 9 사이여야 합니다.',
  kpi_already_selected_brand_warning:
    '이 브랜드를 선택했습니다. 다른 브랜드를 선택하십시오.',
  kpi_no_kpi_informed_warning:
    'KPI값이 입력되지 않았습니다. 값을 추가해 주세요 .',
  kpi_select_year_warning: '연도 선택',
  kpi_select_site_warning: '공장 선택',
  kpi_existing_configuration_warning:
    '동일한 공장 및 연도의 kpi 값이 있습니다.',
  kpi_target_empty_warning: '브랜드 중 하나의 대상이 비어 있습니다.',
  kpi_saved_successfully: '값이 성공적으로 저장되었습니다!',
  kpi_submitted_successfully: '값이 성공적으로 제출되었습니다!',
  kpi_max_decimals_warning: '목표 값은 소수점 3자리 이내여야 합니다.',
  kpi_count_as_kpi_sample: 'KPI로 계산',
  samples_uncheck_kpi_sample_tooltip:
    '이 샘플을 KPI에 포함하지 않으려면 이 칸을 선택 취소합니다.',
  reports_mandatory_zone_filter: '존을 하나 이상 선택하십시오.',
  common_approve_reject: '승인/거부',
  common_approve: '승인',
  submission_type: '제출 유형',
  custom_scale_title: '사용자 정의 표준',
  custom_scale_grid_header_score: '평균 주요 점수',
  custom_scale_grid_header_ageind_scale: '강제 노화 표준',
  the_value_cannot_be_null: '값은 비워 둘 수 없습니다!',
  unique_id: '고유 ID',
  report_filter_rounds_description:
    '라운드 옵션을 로드하려면 필수 필드를 선택해야 합니다.',
  reports_mandatory_test_type: '테스트 유형을 선택하십시오.',
  round_reports_month_warning: '날짜 범위는 최대 6개월이어야 합니다.',
  zone_can_not_empty: '존은 비워 둘 수 없습니다 !',
  error_loading_data:
    '데이터를 로드하는 동안 오류가 발생했습니다. 연결을 확인하고 다시 로드하십시오.',
  beer_batch: '맥주 배치',
  list_of_beers: '맥주 목록',
  random: '랜덤',
  preview: '미리 보기',
  select_the_flavor: '플레이버 선택',
  flavor_threshold: '플레이버 임계값',
  input_digital_number: '디지털 번호 입력...',
  concentration: '농도',
  flavor_order: '플레이버 순서',
  last: '지난',
  tasting: '관능',
  tasting_page_description: '샘플 관능 평가를 수행하고 결과를 토론합니다.',
  confirmation: '확인',
  do_you_confirm_the_evaluation_of_this_sample:
    '이 샘플의 관능을 확인하시겠습니까?',
  confirm: '확인',
  evaluate: '관능',
  correct_answer: '정답',
  threshold: '임계값',
  let_a_comment_about_the_tasting: '관능에 대한 코멘트를 주세요.',
  send: '보내기',
  right_now: '지금',
  minute_ago: '분 전',
  hour_ago: '시간 전',
  day_before: '일 전',
  year_ago: '년 전',
  add_a_flavor: '플레이버 추가',
  soft_drinks: '청량 음료',
  soft_drinks_brand: '청량 음료 브랜드',
  soft_drinks_brand_target: '청량 음료 브랜드 목표',
  column_options: '열 옵션',
  configure_table_title: '열 사용자 지정',
  configure_table: '테이블 구성',
  configure_table_description: '표시할 열을 선택하고 순서를 조정하세요.',
  configure_table_helper:
    '최소 2개의 열이 표시되어야 하며 최대 4개의 열을 고정할 수 있습니다.',
  configure_table_fixed_left: '왼쪽 고정',
  configure_table_scroll_area: '스크롤 영역',
  configure_table_fixed_right: '오른쪽 고정',
  configure_table_empty_left: '열을 여기로 끌어 왼쪽에 고정하세요',
  configure_table_empty_right: '열을 여기로 끌어 오른쪽에 고정하세요',
  configure_table_save: '변경 사항 저장',
  configure_table_reset: '기본값으로 재설정',
  configure_table_discard: '변경 사항 취소',
  configure_table_show: '표시',
  configure_table_hide: '숨기기',
  configure_table_min_visible: '최소 2개의 열이 표시되어야 합니다',
  configure_table_max_fixed: '최대 4개의 열을 고정할 수 있습니다',
  configure_table_drag: '끌어서 순서 변경',
  configure_table_dragging: '끌어오는 중',
  select_which_of_the_columns_do_you_want_to_be_displayed:
    '표시할 열을 선택합니다.',
  countdown: '카운트다운',
  less_than_five_minutes:
    '관능은 5분 후에 종료됩니다. 진행해야 할 경우 관리자에게 연락하여 시간을 연기하십시오.',
  the_countdown_to_the_evaluation_has_ended:
    '카운트다운이 종료되었으며 평가에 참여할 수 없습니다.',
  counting_how_much_time_does_you_have_to_finish_tasting_the_samples:
    '샘플 평가 완료하는 게에 얼마나 시간이 걸리는지 계산',
  only_six_flavors_can_be_added_at_most: '최대 6가지 맛만 추가할 수 있습니다 !',
  concentration_of_the_flavor: '플레이버 농도',
  input_value: '입력해 주세요.',
  Concentration_of_the_flavor_is_required: '플레이버 농도는 필수입니다.',
  previous_round: '이전 라운드',
  next_round: '다음 라운드',
  the_end_time_is_greater_than_the_current_time:
    '종료 시간은 현재 시간보다 커야 합니다. 현재 날짜와 동일한 날짜를 선택할 경우, 시간과 분을 먼저 선택합니다!',
  check_the_answer_at_the_end_of_the_countdown:
    '카운트다운이 0이 될 때까지 기다려서 결과를 확인하세요.',
  incremental_step: '증분 단계',
  set3_concentration: 'Set3 농도',
  concentration_increments_between_levels: '수준 간 농도 증가',
  incremental_set3_concentration_required:
    '증분 단계 및 Set3 농도가 필요합니다',
  sprint: 'Sprint',
  sprint_number_greater_than_zero: '스프린트 번호는 0보다 커야 합니다.',
  sprint_notes_at_least_one_note:
    '스프린트 노트에는 최소한 하나의 노트가 있어야 합니다.',
  sprint_patch_notes_success_update:
    '스프린트 패치 노트가 성공적으로 업데이트되었습니다.',
  sprint_patch_notes_error_update: '노트를 저장할 수 없습니다.',
  sprint_number: '스프린트 번호',
  sprint_patch_notes: '스프린트 패치 노트',
  note: '노트',
  select_all: '전체 선택',
  please_add_samples_first: '먼저 샘플을 추가하십시오',
  reverse: '뒤집다',
  score_scale: '테스트 추가',
  description: '설명',
  aditional_criteria: '추가 기준',
  new_test: '새로운 테스트',
  triangle_test: '삼각 테스트 이름',
  triangle_test_name: '삼각 테스트',
  you_can_not_set_three_identical_samples:
    '세 개의 동일한 옵션을 설정할 수 없습니다',
  its_mandatory_to_input_test_name: '테스트 이름을 기입해 주세요',
  its_mandatory_to_input_sample_information: '샘플 정보를 기입해 주세요.',
  attention: '팁',
  test_number: '테스트 번호',
  you_selected_the: '선택한 샘플은',
  next_sample: '다음 샘플',
  remove_triangle_test: '테스트 삭제',
  test: '테스트',
  confirm_remove: '테스트를 삭제하시겠습니까?',
  you_can_only_select_up_to_five: '최대 5개까지 선택할 수 있습니다',
  reports_mandatory_zone_country_site_filter: '존, 국가, 공장이 필요합니다!',
  reports_mandatory_brand_filter: '하나 이상의 브랜드를 선택합니다',
  download_label: '다운로드 버튼',
  reports_by_producing_site: '평가 보고서(공장/브랜드)',
  standard: '표준 값',
  input_test: '수동 입력',
  detecting: '탐지 중...',
  connected: '연결됨',
  current_taster: '현재 품평원',
  alcohol_concentration: '알코올 농도',
  alcohol_result_submit_failed_title: '결과를 제출하는 중 문제가 발생했습니다',
  alcohol_result_submit_failed_desc: '잠시 후 다시 시도해 주세요.',
  your_alcohol_test_result_exceeds_standard_please_test_again_later:
    '혈중 알코올 농도가 기준을 초과했습니다. 늦게 다시 테스트 진행해주세요!',
  alcohol_test_qualified: '알코올 검사 합격',
  alcohol_concentration_configuration: '알코올 농도 구성',
  breathalyzer_configuration_description: '각 사이트의 알코올 농도와 사용자 운전 상태를 구성합니다.',
  breathalyzer_configuration_save_success_title: '음주 측정기 구성이 성공적으로 업데이트되었습니다!',
  breathalyzer_configuration_save_success_description: '아래 설정에서 업데이트된 구성을 확인하세요.',
  breathalyzer_configuration_save_failed_title: '음주 측정기 구성 업데이트 중 문제가 발생했습니다',
  breathalyzer_configuration_save_failed_description: '잠시 후 다시 시도해 주세요.',
  cancel_configuration_title: '구성을 취소하시겠습니까?',
  cancel_configuration_description: '구성을 변경했습니다. 취소하면 저장하지 않은 변경 사항이 삭제됩니다. 계속하시겠습니까?',
  cancel_configuration_confirm: '구성 취소',
  driving_configuration: '운전 구성',
  configuration: '배치',
  input_result: '결과 입력',
  maximum_alcohol_concentration: '최대 알코올 농도',
  breathalyzer: '음주 측정기',
  breathalyzer_page_description:
    '한 곳에서 모든 음주 측정 결과와 구성 기준을 관리하세요.',
  please_input_a_positive_number_up_to_n_decimal_places:
    '소수점 {{field}자리까지 양수를 입력하십시오',
  you_must_input: '입력해야 합니다',
  driving: '운전 여부',
  test_time: '테스트 시간',
  input_type: '입력 방식',
  list_breathalyzer: '음주 측정기',
  Manual: '매뉴얼',
  auto: '자동',
  Breathalyzer: '음주 측정기',
  you_do_not_have_privilege_to_export_this_report:
    '이 보고서를 내보낼 권한이 없습니다.',
  competitor_beer: '경쟁있는 맥주',
  split_round: '라운드 분할',
  reset: '리셋',
  how_many_rounds_splitting_do_you_want_to_make: '몇 라운드를 분할하시겠습니까',
  you_cannot_split_a_round_that_has_already_been_split_or_in_progress:
    '이미 분할되었거나 진행 중인 라운드는 분할할 수 없습니다.',
  hide_sample_details: '샘플 정보 숨기기',
  hide_sample_details_auto_hide:
    'YES - 샘플을 분할하고 분할된 모든 라운드를 시음한 후 숨겨진 모든 정보를 자동으로 표시할 수 있습니다.',
  hide_sample_details_auto_hide_off:
    'Manual - 샘플을 분할할 수 없으며 토론 페이지에서 숨김 해제 또는 숨기기를 수동으로 전환하려면 임시 관리자를 지정해야 합니다.',
  data_will_be_hidden_from_the_taster_brewery_production_date_brand_malt_variety_and_sample_id:
    '공장, 생산 일자, 브랜드, 맥아 품종 및 샘플 ID에 관한 정보는 관능자에게 숨겨집니다.',
  this_round_is_selected_manual_unhide_split_function_is_not_available_you_can_choose_auto_hide_or_no_hide_to_split:
    '이번 라운드는 Manual 으로 선택되어 분할 기능을 사용할 수 없으며, 자동 숨기기 또는 숨기기 안 함을 선택하여 분할할 수 있습니다.',
  data_will_be_hidden_for_ok_nok: '모든 관련 데이터는 테스터에게 숨겨집니다.',
  you_can_not_add_duplicate_attributes: '중복적인 맛을 선택할 수 없습니다.',
  menu: '메뉴',
  link_breathalyzer: '연결된',
  not_link_breathalyzer: '미연결',
  breathalyzer_to_link: '음주 측정기 연결',
  breathalyzer_connection_failed_title: '음주 측정기 연결 실패',
  breathalyzer_connection_failed_desc:
    '페이지를 새로 고친 후 다시 시도해 주세요.',
  breathalyzer_can_not_to_link_for_this_browser:
    'PC의 구글 크롬을 사용하여 음주 측정기 데이터를 읽으세요.',
  reopen: '다시 열기',
  round_reopen_message: '이 라운드를 다시 여시겠습니까',
  common_production_line: '공정',
  common_packaged_beer_data_code: '패키지 맥주 데이터 코드',
  common_masking_process_for_bottles: '병 마스킹 프로세스',
  common_str_number_days_over_aged: '초과 일수',
  common_over_aged_beer: '시간 초과 맥주',
  sample_successfully_swapped: '샘플이 성공적으로 교환되었습니다',
  scoring: '득점',
  configure_available_flavors: '맛에 옵션 설정',
  process_check: '온라인 관능',
  new_process_check: '온라인 관능 작성',
  edit_process_check: '온라인 관능 편집',
  remove_process_check: '온라인 관능 삭제',
  common_package: '패키지',
  common_department: '부서',
  common_shift: '교대조',
  common_tank: '탱크',
  common_oknok: 'OKNOK',
  common_remark: '비고',
  show_all_process_check: '모든 평가 데이터 보여주기',
  show_all_process_check_help_circle:
    '오늘부터 6개월 이내에 생성된 데이터를 표시합니다. 1년 내 데이터를 필요하면 이 확인란을 선택하세요.',
  the_sample_date_cannot_be_earlier_than_the_current_time:
    '생플링 시간은 현재 시간보다 클 수 없습니다.',
  common_job_position: '포지션',
  decimal_sep: '소수점',
  is_swapped_to: '로 교환됨',
  continuous_typing: '연속 입력',
  continuous_typing_tips: "'강도'를 선택/입력한 후 '속성'을 연속 입력",
  review_warning_comment_title: '평가 입력하지 않은 샘플이 있습니다!',
  BSSI_Reports: 'BSSI 리포트',
  data_analysis_sip: '데이터 분석 - SIP',
  select_the_color: '색깔 선택',
  color: '색깔',
  download_document: '파일 다운로드',
  Month_of_Discontinued_Production: '생산 중지 월',
  Suspension_List: '생산 중지 리스트',
  New_Suspension: '새 생산 중지신청',
  new_suspension_page: '새로운 생산 중지 정보',
  edit_suspension_page: '생산 중지 정보 편집',
  Brand_name: '브랜드명',
  List_Brewery_Production_Suspension: '공장 생산 중지 리스트',
  Upload_successfully: '업로드 성공',
  training_materials: '교육 자료',
  Remove_Suspension: '생산중지 정보 삭제: ',
  Add_Absence_Reason: '결석 이유 추가',
  Reason: '이유',
  Select_reason: '이유 선택',
  You_have_duplicate_absence_dates: '결석 날짜가 중복됩니다',
  Remove_Absence: '결석 정보 삭제 : ',
  Absence_Title:
    '시음 결석 시간과 사유를 선택해 주세요. 제출된 사유에서 항목을 확인하거나 삭제할 수 있습니다.',
  Shipping_Site: '수취 공장',
  shipping_received: '도착 확인',
  receive_sample_alert: '샘플 수령 확인하시겠습니까?',
  receive_uncheck_alert: '선택한 것 취소하시겠습니까?',
  all_received: '모두 접수',
  not_all_received: '모두 접수 아님',
  not_for_shipping: '발송 필요 없음',
  receive_hint: '해당 샘플 접수 필요한 모든 공장을 선택해 주세요.',
  absence_reason: '결석 이유',
  Page1: '{{field}} 페이지',
  Search: '검색',
  page_total: '전체',
  start_date: '시작 날짜',
  end_date: '종료 날짜',
  ok_for_all: '전체 OK ',
  its_mandatory_to_select_sample_A_and_sample_B:
    '샘플A 와 샘플 B는 비워 둘 수 없습니다.',
  its_mandatory_to_select_sample_A: '샘플A는 비워 둘 수 없습니다. ',
  its_mandatory_to_select_sample_B: '샘플B는 비워 둘 수 없습니다. ',
  triangle_comment: '코멘트',
  select_sample: '샘플 선택',
  sample_date_filter_last_7_days_in_default_export_to_Excel_based_on_this_filtered_duration:
    '샘플 날짜 필터는 자동적으로 최근 7일로 설정되며 선택한 기간에 따라 관능 데이터가 내보냅니다.',
  select_all_flavor: '모든 플레이버 선택',
  deselect_all: '모든 선택 취소',
  the_score_entered_is_invalid:
    '입력한 점수가 잘못되었습니다.분수표를 참고하여 점수를 다시 입력하십시오.',
  service_now: '클릭해서 티켓을 만들어 문제를 보고하고 도움을 받습니다.',
  service_now_tips:
    '시스템 사용 중 문제가 발생하거나 도움을 필요하실 때 여기에서 ServiceNow로 보고서를 보내주시면 저희가 연락드리겠습니다.',
  changes_you_made_may_not_be_saved:
    '변경 사항을 저장하지 못할 수 있습니다.계속하고 변경 사항을 잃으시겠습니까?',
  cannel_auto_save_tips:
    '관능 페이지 성능 향상 완료되었습니다. 관능 완료를 클릭하여 관능 결과를 저장하고 제출하는 것을 기억하시기 바랍니다.',
  add_samples: '라운드에 샘플 추가',
  copy_this_sample: `샘플 복제`,
  remove_this_sample: `샘플 제거`,
  drag_samples_here: `샘플을 여기로 끌어오세요`,
  drop_here: `여기에 놓으세요`,
  multiple_selection_tips: `동일한 샘플 유형에 대해 한 번에 여러 개의 샘플을 선택할 수 있습니다. '+' 및 '-'를 클릭하여 시도해 보세요.`,
  all_add_once_tips: `'모두 선택' 버튼을 클릭하면 선택한 각 샘플 유형에 1개의 샘플이 자동으로 추가됩니다.`,
  copy_confirm_tip: `샘플을 복제하시겠습니까?`,
  user_non_abi_user: '새 임시 사용자',
  language_of_email_invitation: '이메일 초대 언어',
  add_non_abi_users_to_round:
    '임시 테스터에게는 특정 시음회에 참석할 수 있는 링크가 포함된 이메일 초대장이 발송됩니다.',
  change_non_abi_users_to_round:
    '초대받은 임시 사용자에게는 이 시음회에 참석할 수 있는 링크가 포함된 이메일 초대장이 발송됩니다.',
  guest: '게스트',
  email_to_all: '모두에게 이메일 보내기',
  send_email: '초대 이메일 보내기',
  temporary_non_abi_taster: '임시 테스터',
  user_type: '사용자 유형',
  email_invitation_delivery_request_sent: '초대 이메일 요청이 전송되었습니다.',
  incorrect_e_mail_formatting: '잘못된 이메일 서식',
  all_tasters: '모든 테스터',
  tasters: '테스터',
  key_tasters: '핵심 테스터',
  non_key_tasters: '중요하지 않음 테스터',
  taster_already_started_cannot_change:
    '테스터가 이미 시작되었습니다, 변경할 수 없습니다',
  temporary: '임시 사용자',
  maximum_number_of_samples_is: `최대 샘플 수는 다음과 같습니다`,
  sample_added: '샘플 추가',
  click_to_view_scale_of_flavour_intensities: `자세한 강도 척도를 보려면 링크를 클릭하세요.`,
  documents_upload_tips: '파일 업로드는 {{field}} 만 지원합니다',
  ignore_submit: '취소&전송',
  if_count_as_kpi:
    'KPI에 샘플을 단계하고 저장하고 제출하는 것을 기억하시기 바랍니다',
  list_next_week_plan: '다음 주 계획',
  common_time_zone: '시간대',
  common_last_response_time: `마지막 응답 시간`,
  new_week_plan: '새 주 계획',
  invited_week: '초대받은 주',
  email_language: `이메일 언어`,
  save_and_send_email: `이메일 저장 및 보내기`,
  common_start_time: '시작 시간',
  common_end_time: '종료 시간',
  session_name_email_subject: `세션 이름 / 이메일 제목`,
  location: '위치',
  edit_week_plan: '주 계획 변경',
  email_response: '이메일 응답',
  round_remove_plan: '요금제를 삭제하시겠습니까',
  view_week_plan: '주간 요금제 보기',
  are_you_confirming_to_send_the_confirmation_email: `확인 이메일 전송을 확인하시겠습니까`,
  every_10_minutes_system_will_update_the_email_response_from_next_week_plan_invitation: `10분마다 시스템이 다음 주 플랜 초대의 이메일 응답을 업데이트합니다`,
  confirmed_count: '확인된 수',
  accepted: '수락됨',
  declined: '거부됨',
  no_response: '응답 없음',
  reminder_time: '알림 시간',
  are_you_sure_you_want_to_change_the_week_of_invitation:
    '선택한 세션 시작/종료 시간을 제거하고 다른 초대된 주간으로 변경하시겠습니까',
  apply_to_all_sessions_location_tasters: `다음 세션에 '위치' 및 '관능자'를 적용합니다.`,
  mcs_tasting: 'KPI 관능',
  qcs_tasting: 'KPI 관능',
  mcs_tasting_tips:
    '이 라운드에 MCS/KPI 샘플이 포함되어 있으면 예를 선택하면 시스템에서 샘플 브랜드별로 관련 KPI 코드를 적용합니다.',
  round_samples_shuffle_confirm: '세트를 섞으시겠습니까?',
  all_count_as_kpi: '모두 KPI로 계산',
  msc_tasting_tour_mask:
    '시스템은 올바른 KPI 월로 카운트된 샘플을 기반으로 관련 KPI 코드를 자동으로 식별하므로 한 라운드에서 여러 브랜드를 분할할 필요가 없습니다.',
  competition: 'Competition',
  copy_link: '링크 복사',
  open_link: '새 탭에서 열기',
  common_download_img: '사진 다운로드',
  please_select_taster: '테스터를 선택하세요',
  user_principal_name: '사용자 계정 이름',
  user_status: '사용자 상태',
  termination_date: '종료 날짜',
  function_level: '기능 수준',
  last_update_time: '마지막 업데이트 시간',
  system_related: '시스템 관련',
  workday_related: 'WorkDay 관련',
  employee_id: '근로자 ID',
  zitec_project_name: '프로젝트 이름',
  applicant: '신청자',
  applicant_date: '신청 날짜',
  test_method: '테스트 방법',
  liquid_category: '액체 카테고리',
  conditions: '조건',
  time_points: '시점',
  execution_date: '실행 날짜',
  execution_by_time_points: '시점별 계산된 실행 날짜',
  invitation_start_time: '초대 시작 시간',
  invitation_end_time: '초대 종료 시간',
  invitation_reminder: '초대 알림',
  application_form: '신청 양식',
  application_form_result: '신청 양식 결과',
  upload_result: '결과 업로드',
  zitec_sessions: 'ZITEC 세션',
  zitec_id: 'ZITEC ID',
  new_zitec_session: '새로운 ZITEC 세션',
  common_search_applicant: '신청자 검색',
  history_record: '이력 기록',
  common_quarterly: '분기별',
  common_month: '월',
  kpi_report: 'KPI 보고서',
  kpi_result: 'Anaplan 파일',
  action_log: '작업 로그',
  validate_data: '데이터 검증',
  push_anaplan_window_open_date: 'Anaplan 창 열기 날짜를 푸시합니다:',
  unLock_kpi: 'KPI 잠금 해제',
  lock_kpi: 'KPI 잠금',
  locked: '잠김',
  unlocked: '잠금 해제',
  menu_kpi_lock: 'KPI 잠금',
  freshness_kpi_lock: '신선도 잠금',
  in_profile_kpi_lock: 'In Profile 잠금',
  are_you_sure_you_want_to_lock_kpi: '{{field}}의 KPI를 잠그시겠습니까',
  are_you_sure_you_want_to_unlock_kpi:
    '{{field}}의 KPI 잠금을 해제하시겠습니까',
  anaplan_un_upload_tips: '다음 Anaplan 창이 열릴 때까지 기다려주세요!',
  anaplan_un_confirm_tips: '주어진 월의 KPI 데이터를 확인하십시오!',
  lock_kpi_month_zone:
    '지정된 KPI 월 잠금으로 인해 작업이 실패했습니다. 문의 사항이 있으시면 Zone Owner에게 연락하여 KPI 데이터 잠금 관련 상세 내용을 확인하세요.',
  lock_freshness_kpi_month_zone:
    '지정된 KPI 분기 잠금으로 인해 작업이 실패했습니다. 문의 사항이 있으시면 Zone Owner에게 연락하여 KPI 데이터 잠금 관련 상세 내용을 확인하세요.',
  submit_timeout: '제출 요청 실패, 나중에 다시 시도해 주세요!',
  confirmed: '뿌리 깊었어',
  confirm_data: '데이터 확인',
  flavor_groups: `플레이버 그룹`,
  compound: '화합물',
  sit_code_not_exist:
    '이 코드는 존재하지 않습니다. 코드 형식이 맞는지 확인해 주세요. 예시:001, 002',
  sit_code_chose:
    '입력하신 코드는 사용할 수 없습니다. 정확한 번호를 다시 입력해 주세요.',
  kpi_lock: 'KPI 잠금',
  kpi_confirmation: 'KPI 확인',
  global_kpi_lock: 'Global KPI 잠금',
  select_month: '월 선택',
  need_to_wait_global_lock: '글로벌이 잠길 때까지 기다려야 합니다.',
  monthly_kpi_locked_zones: '월별 KPI 잠긴 영역',
  flavor_confirm_save: `선택하지 않은 맛 '{{field}}'가 추가된 샘플에 있습니다. 현재 플레이버 구성을 저장하도록 확인하면 해당 샘플이 삭제됩니다`,
  temporary_admin: '임시 관리자',
  unhide_sample_details: '샘플 세부 정보 숨기기 해제',
  hide_sample: '샘플 숨기기',
  download_report_timeout_error_message:
    '액세스 시간 초과, 네트워크 연결을 확인하세요.',
  you_can_only_select_up_to:
    '최대 {{field}} 까지만 선택할 수 있습니다. 선택 수를 줄이십시오.',
  push_anaplan: '푸시 아나플랜',
  pushed: '푸시 완료',
  self_evaluation_report: '자체 평가 보고서를 다운로드하려면 클릭하세요',
  date_range: '날짜 범위',
  kpi_month_range: 'KPI 월 범위',
  quick_select: '빠른 선택',
  current_month: '현재 월',
  current_year: '현재 연도',
  a_whole_year: '일 년 내내',
  download_self_evaluation_report: '자체 평가 보고서 다운로드',
  select_tasters: '체험단 선택',
  create_ticket: '티켓 생성',
  sensory_intelligent_platform: 'Sensory 지능형 플랫폼 - PBI',
  external_links: '외부 링크',
  evaluation_report: '평가 보고서',
  download_evaluation_report: '평가 보고서 다운로드',
  taster_type: '테스터 유형',
  taster_evaluation_tip:
    '이제 여기를 클릭하여 자기 평가 보고서를 다운로드할 수 있습니다!',
  admin_evaluation_tip:
    '이제 여기를 클릭하여 테스터 평가 보고서를 다운로드할 수 있습니다!',
  kpi_sample: 'KPI 샘플',
  add_to_download_list: '다운로드 목록에 추가',
  to_download_list: '다운로드',
  selected_tasters: '선택된 테스터',
  generation_time: '생성 시간',
  start_month: '시작 월',
  end_month: '종료 월',
  download_all: '모두 다운로드',
  new_physchem_tips:
    '이제 여기 클릭하여 샘플에 물리화학적 특성을 추가할 수 있습니다.',
  view_physchem_tips: `이제 여기 클릭하여 현재 라운드의 샘플 물리화학적 특성을 확인할 수 있습니다.`,
  physchem_disabled_tips: '샘플이 숨겨져 있을 때 Phychem을 볼 수 없습니다.',
  package_code: `패키지 코드`,
  concentration_at_fu: '1 풍미 단위 농도',
  base_beer: '베이스 맥주',
  flavor_intensities_scale: `풍미 강도 척도`,
  flavor_unit: '맛 단위',
  add_a_sample: '샘플 추가',
  common_kpi_quarter: 'KPI 분기',
  sample_duplicated_quarter_kpi_message:
    '선택하신 분기, 브랜드 및 사이트에 대한 KPI가 이미 존재하므로 저장할 수 없습니다.',
  select_quarter: '분기 선택',
  please_select_kpi_quarter: 'KPI 분기 선택해 주세요',
  error_fields: `오류 필드`,
  your_answer: '귀하의 답변',
  preference: '선호',
  please_select_preference_group: '제출하기 전에 선호도를 선택해야 합니다!',
  monthly_report: '월간 보고서',
  draft: '초안',
  confirm_send: '확인 및 발송',
  sent_completion: '발송 완료',
  send_draft: '초안 발송',
  send_draft_monthly_report: '월간 보고서를 귀하의 이메일 주소로 발송합니다.',
  please_confirm_the_recipients: '월간 보고서 수신자를 확인해 주세요',
  total_recipients: '총 수신자 수',
  sending: '발송 중',
  sending_monthly_report_tips1: `귀하의 요청이 현재 처리 중입니다.`,
  sending_monthly_report_tips2: `결과는 “작업 로그”에서 확인해 주세요.`,
  configure_upgrade_center: '업그레이드 센터 구성',
  sprint_content: '스프린트 콘텐츠',
  release_date: '출시일',
  add_sprint: '스프린트 추가',
  sprint_meterials: '스프린트 자료',
  upgrade_center: '업그레이드 센터',
  function: '기능',
  my_evaluation_report: '내 평가 보고서',
  upgrade_center_remove_sprint_number:
    '이 스프린트 번호를 정말 삭제하시겠습니까',
  sprint_version_tips: '스프린트 자료를 보려면 클릭하세요.',
  edit_sprint: '스프린트 수정',
  new_sprint_tips: '이제 여기 클릭하시면 스프린트 자료를 보실 수 있습니다',
  production_date_range: '생산일자 범위',
  preparation: '준비',
  panel: '패널',
  session: '세션',
  product: '제품',
  attribute: '속성',
  common_menu_samples: '샘플',
  common_menu_rounds: '라운드',
  common_menu_groups: '그룹',
  common_menu_suspension_list: '정지',
  common_menu_planning_week_sessions: '계획 주 세션',
  common_menu_zitec_sessions: 'ZITEC 세션',
  common_menu_brands: '브랜드',
  common_menu_kpi_brands: 'KPI 브랜드',
  common_menu_packages: '패키지',
  common_menu_styles: '스타일',
  common_menu_malt_variety: '맥아 품종',
  common_menu_intensities: '강도',
  common_menu_categories: '카테고리',
  common_menu_attributes: '속성',
  common_menu_user_management: '사용자 관리',
  common_menu_role_management: '역할 관리',
  common_menu_permission_control: '권한 제어',
  system: '시스템',
  select_taste_type: '관능 유형 선택',
  select_round: '라운드 선택',
  a_previous_request_is_still_being_processed:
    '이전 요청이 아직 처리 중입니다. 나중에 다시 시도해 주세요.',
  select_item: '{{field}} 선택',
  common_new_kpi_brand_button: '새 KPI brand',
  common_target: '목표',
  common_focus_brands: '포커스 브랜드',
  common_strategic_brands: '전략 브랜드',
  kpi_brands_new_page_description:
    '새 KPI 브랜드 생성 인터페이스, KPI 브랜드 정보 입력, 제출 및 저장 기능.',
  kpi_brands_edit_page_description:
    'KPI 브랜드 편집 인터페이스, KPI 브랜드 정보 업데이트, 제출 및 저장 기능.',
  kpi_brands_edit_page_description_prefix: 'KPI 브랜드 보기 및 구성 ',
  kpi_brands_page_description:
    'KPI 브랜드 관리 인터페이스, 보기, 제출 및 검토 기능.',
  table_apply: '적용',
  table_clear: '지우기',
  table_search: '검색',
  table_enter_to_filter: '필터링하려면 입력...',
  table_select_to_filter: '필터링하려면 선택...',
  table_select_all: '전체 선택',
  table_select_all_aria: '모든 행 선택',
  table_select_row_aria: '행 선택',
  table_filter_by: '필터',
  table_clear_filters: '필터 지우기',
  table_reset_filters: '필터 재설정',
  table_no_results_for_filters: '적용된 필터에 대한 결과가 없습니다.',
  table_items_selected: '항목 선택됨',
  table_sort: '정렬',
  table_sort_toggle: '클릭하여 정렬을 전환하세요',
  table_no_options: '사용 가능한 옵션 없음',
  table_reset: '재설정',
  table_all: '전체',
  table_no_results: '적용된 필터에 대한 결과가 없습니다',
  common_approved_at: '{{date}}에 승인됨',
  common_rejected_at: '{{date}}에 거절됨',
  kpi_status_created: '생성됨',
  kpi_status_waiting_for_approval: '승인 대기 중',
  kpi_status_approved: '승인됨',
  kpi_status_rejected: '거절됨',
  kpi_action_approve: '승인',
  kpi_action_reject: '반려',
  common_by_user: '{{user}}에 의해',
  pagination_aria_label_next_page: '다음 페이지로 이동',
  pagination_aria_label_previous_page: '이전 페이지로 이동',
  pagination_aria_label_first_page: '첫 페이지로 이동',
  pagination_aria_label_last_page: '마지막 페이지로 이동',
  pagination_aria_label_input:
    '원하는 페이지를 입력하세요 (1부터 {totalItems}까지)',
  pagination_aria_label_items_per_page:
    '페이지당 {pageSize}개 항목 선택됨, 변경하려면 클릭',
  pagination_lines_per_page: '페이지당 줄 수',
  pagination_total_pages: '/ {totalPages}',
  pagination_total_elements: '{totalItems}개 중 {firstItem}-{lastItem}개 결과',
  pagination_no_results: '결과를 찾을 수 없습니다',
  kpi_brand_successfully_saved: 'KPI brand가 성공적으로 저장되었습니다!',
  kpi_brand_saved_description:
    '아래 KPI brand에서 확인하세요. 이는 임시 저장이며, 승인 제출은 아직 완료되지 않았습니다.',
  kpi_brand_failed_to_save: 'KPI brand 저장에 실패했습니다.',
  kpi_brand_save_failed_description: '잠시 후 다시 시도해 주세요.',
  kpi_brand_successfully_submitted: 'KPI brand가 성공적으로 생성되었습니다!',
  kpi_brand_submitted_description:
    '아래 KPI brand에서 확인해 주세요. 상세 페이지에서 승인 진행 상황을 확인해 주세요; 이 KPI brand는 승인 후에만 사용할 수 있습니다.',
  kpi_brand_failed_to_submit: 'KPI brand 생성에 실패했습니다.',
  kpi_brand_submit_failed_description: '잠시 후 다시 시도해 주세요.',
  flavor_id_discussion: '플레이버 식별 토론',
  view_and_discussion_for: '보기 및 토론',
  common_cup: '컵',
  tasters_joined: '참여 테스터',
  tasters_all_correct: '전부 정답 테스터',
  total_accuracy: '전체 정확도',
  accuracy: '정확도',
  all_correct: '전부 정답',
  otherwise: '기타',
  result: '결과',
  Key: '핵심',
  nonkey: '비핵심',
  common_guest: '게스트',
  view_correct_answers: '정답 보기',
  hide_correct_answers: '정답 숨기기',
  change_to_table: '테이블로 전환',
  change_to_card: '카드로 전환',
  not_answered: '미응답',
  actions: '액션',
  actions_page_description: '시음 세션 중 사용자가 생성한 모든 액션을 봅니다.',
  action_created_by: '생성자',
  my_actions: '내 액션',
  action_list_info: '액션은 라운드 종료 후 생성됩니다.',
  unsaved_changes_warning:
    '저장하지 않은 변경 사항이 있습니다. 나가시겠습니까?',
  common_go_back: '뒤로',
  cancel_create_action_title: '액션 생성을 취소하시겠습니까?',
  cancel_edit_action_title: '액션 편집을 취소하시겠습니까?',
  cancel_create_action_confirm: '액션 생성 취소',
  cancel_edit_action_confirm: '액션 편집 취소',
  unsaved_changes_description:
    '양식에 입력한 내용이 있습니다. 취소하면 저장하지 않은 입력 내용이 삭제됩니다. 계속하시겠습니까?',
  unsaved_changes_edit_description:
    '양식의 내용을 변경했습니다. 취소하면 저장하지 않은 변경 사항이 삭제됩니다. 계속하시겠습니까?',
  action_update_failed_desc: '잠시 후 다시 시도해 주세요.',
  action_change_status_successfully: '상태가 변경되었습니다!',
  action_change_status_successfully_desc:
    '액션 상태가 {{status}}(으)로 변경되었습니다.',
  action_change_status_failed: '상태를 변경하지 못했습니다',
  action_change_status_failed_desc:
    '액션 상태를 변경하지 못했습니다. 다시 시도해 주세요.',
  download_report_success: '보고서가 성공적으로 다운로드되었습니다!',
  download_report_success_desc: '다운로드 폴더에서 확인해 주세요.',
  download_self_evaluation_report_success:
    '자체 평가 보고서가 성공적으로 다운로드되었습니다!',
  download_report_failed: '보고서 다운로드에 실패했습니다.',
  download_report_failed_desc: '잠시 후 다시 시도해 주세요.',
  evaluation_report_add_success: '보고서가 성공적으로 추가되었습니다!',
  evaluation_report_add_success_desc:
    "'다운로드' 평가 보고서에서 확인해 주세요.",
  evaluation_report_add_failed: '보고서를 추가하지 못했습니다.',
  evaluation_report_add_failed_desc: '잠시 후 다시 시도해 주세요.',
  add_taster: '관능자 추가',
  alcohol_concentration_result: '알코올 농도 결과',
  absence_save_success: '부재 사유가 성공적으로 추가되었습니다!',
  absence_save_success_desc: '제출된 부재에서 확인하세요.',
  submitted_absence: '제출된 부재',
  no_absence_to_show: '표시할 부재가 없습니다',
  no_more_data: '더 이상 데이터가 없습니다',
  absence_delete_success: '부재 사유가 성공적으로 삭제되었습니다!',
  absence_delete_success_desc: '제출된 부재에서 업데이트된 목록을 확인하세요.',
  absence_delete_confirm_title: '부재를 삭제하시겠습니까?',
  absence_delete_confirm_description: '[{{start}} - {{finish}}] 부재 기록이 영구적으로 삭제됩니다. 계속하시겠습니까?',
  absence_delete_confirm_delete: '삭제',
  absence_save_failed: '부재 사유를 추가하지 못했습니다',
  absence_save_failed_desc: '잠시 후 다시 시도해 주세요.',
  absence_duplicate_date_desc:
    '선택한 날짜에 이미 부재 기록이 있습니다. 중복 제출은 허용되지 않습니다.',
  absence_delete_failed: '부재 사유를 삭제하지 못했습니다',
  absence_delete_failed_desc: '잠시 후 다시 시도해 주세요.',
  role_management_change_role: '역할 변경',
  role_management_reset_success: '권한이 성공적으로 초기화되었습니다!',
  role_management_reset_success_desc: '이 역할의 권한이 기본 구성으로 초기화되었습니다. 아래 권한 관리에서 확인할 수 있습니다.',
  role_management_reset_failed: '권한을 초기화하지 못했습니다.',
  role_management_reset_failed_desc: '잠시 후 다시 시도해 주세요.',
  role_management_switch_role_title: '변경 사항을 취소하시겠습니까?',
  role_management_switch_role_description: '저장되지 않은 권한 변경 사항이 있습니다. 역할을 변경하면 변경 사항이 취소됩니다. 계속하시겠습니까?',
  role_management_switch_role_confirm: '역할 변경',
  role_management_created: '사용자 지정 역할이 성공적으로 생성되었습니다!',
  role_management_created_desc: '아래 권한 관리에서 확인할 수 있습니다.',
  role_management_permissions_failed: '권한을 불러오지 못했습니다.',
  role_management_create_failed: '역할을 생성하지 못했습니다.',
  role_management_create_required: '역할 이름을 입력하고 권한 집합을 선택하세요.',
  role_management_create_failed_desc: '잠시 후 다시 시도해 주세요.',
  role_management_create_duplicate: '이미 존재하는 역할 이름입니다!',
  role_management_create_duplicate_desc: '다른 역할 이름을 입력하고 다시 시도해 주세요.',
  role_management_save_success: '역할 권한이 성공적으로 업데이트되었습니다!',
  role_management_save_success_desc: '변경 사항이 저장되었습니다. 아래 권한 관리에서 확인할 수 있습니다.',
  role_management_save_failed: '역할 변경 사항을 저장하지 못했습니다.',
  role_management_save_failed_desc: '잠시 후 다시 시도해 주세요.',
  role_management_permission: '기능',
  role_management_view: '보기',
  role_management_edit: '편집',
  role_management_approve: '승인',
  role_management_search: '역할 검색',
  role_management_current_role_prefix: '현재 역할은',
  role_management_create: '사용자 지정 역할 만들기',
  role_management_save_changes: '변경 사항 저장',
  common_apply: '적용',
  role_management_reset_title: '기본 권한으로 재설정하시겠습니까?',
  role_management_reset_tooltip: '[{{parentRole}}] 구성으로 권한 재설정.',
  role_management_reset_description: '역할 권한이 기본 구성으로 재설정되고 모든 수동 변경 사항이 삭제됩니다. 이 작업은 취소할 수 없습니다.',
  cancel_create_role_title: '사용자 지정 역할 만들기를 취소하시겠습니까?',
  cancel_create_role_confirm: '역할 만들기 취소',
  cancel_create_role_description: '양식에 입력한 내용이 있습니다. 취소하면 저장하지 않은 내용이 삭제됩니다. 계속하시겠습니까?',
  role_management_delete_title: '사용자 지정 역할을 삭제하시겠습니까?',
  role_management_delete_preview:
    '{{role}}이(가) 영구적으로 삭제됩니다. 이 역할이 할당된 사용자는 역할과 연결된 모든 권한에 액세스할 수 없게 됩니다. 계속하시겠습니까?',
  role_management_delete_failed: '역할을 삭제하지 못했습니다.',
  role_management_default_role: '기본 역할',
  role_management_delete_preview_no_users: "사용자 지정 역할 '{{role}}'이(가) 영구적으로 삭제됩니다. 계속하시겠습니까?",
  role_management_create_title: '사용자 지정 역할 만들기',
  role_management_role_name: '역할 이름',
  role_management_permission_set: '기본 역할을 기준으로 사용자 지정 권한 설정',
  role_management_role_name_placeholder: '역할 이름 입력',
  role_management_permission_set_placeholder: '기본 역할 선택',
  role_management_reset_success: '권한이 성공적으로 재설정되었습니다!',
  role_management_reset_success_desc: '이 역할의 권한이 기본 구성으로 재설정되었습니다. 아래 권한 관리에서 확인할 수 있습니다.',
  role_management_reset_failed: '권한을 재설정하지 못했습니다.',
  role_management_reset_failed_desc: '잠시 후 다시 시도해 주세요.',
};
